import { doAddEvent, doRemoveEvent } from 'lib/events';
import React from 'react';
import { BackHandler, NativeEventSubscription, Platform } from 'react-native';
import { eventModalBackdropPress } from 'store/actions';

const escRegistry: { index: number; active: number[] } = {
  index: 0,
  active: [],
};

export const useEsc = (callback: (() => void) | undefined | false): void => {
  const thsIndexRef = React.useRef<number>(0);
  if (!thsIndexRef.current) {
    escRegistry.index += 1;
    thsIndexRef.current = escRegistry.index;
  }
  const onKeyDown = React.useCallback(
    (event: KeyboardEvent) => {
      const key = event.key || event.keyCode;
      if (
        escRegistry.active[escRegistry.active.length - 1] ===
          thsIndexRef.current &&
        !event.repeat &&
        (key === 'Escape' || key === 27) &&
        callback
      ) {
        callback?.();
      }
    },
    [callback],
  );
  const onBackPress = React.useCallback(() => {
    if (
      escRegistry.active[escRegistry.active.length - 1] ===
        thsIndexRef.current &&
      callback
    ) {
      callback?.();
      return true;
    }
    return false;
  }, [callback]);
  React.useEffect(() => {
    let modalBackdropPressEvent: number | undefined;
    let backHandlerEvent: NativeEventSubscription | undefined;
    if (Platform.OS !== 'ios') {
      escRegistry.active.push(thsIndexRef.current);
      if (callback) {
        modalBackdropPressEvent = doAddEvent(eventModalBackdropPress, () =>
          onBackPress(),
        );
        if (Platform.OS === 'web') {
          document.addEventListener('keydown', onKeyDown);
        } else {
          backHandlerEvent = BackHandler.addEventListener(
            'hardwareBackPress',
            onBackPress,
          );
        }
      }
    }
    return () => {
      if (Platform.OS !== 'ios') {
        escRegistry.active.splice(
          escRegistry.active.indexOf(thsIndexRef.current),
          1,
        );
        if (callback) {
          if (modalBackdropPressEvent) {
            doRemoveEvent(modalBackdropPressEvent);
          }
          if (Platform.OS === 'web') {
            document.removeEventListener('keydown', onKeyDown);
          } else {
            backHandlerEvent?.remove();
          }
        }
      }
    };
  }, [callback, onBackPress, onKeyDown]);
};
